module.exports = __webpack_public_path__ + "assets/img/icon-803.5dba36be.png";